const dataLayer = (event, modalTitle) =>
    (window.dataLayer || []).push({
        event,
        ...(modalTitle && { modalTitle })
    });

export default dataLayer;
